import React from 'react';

const ShimmerBlock = ({ className = "" }) => (
  <div className={`animate-pulse bg-slate-200 rounded ${className}`} />
);

const NodeSkeleton = () => (
  <div className="w-[280px] bg-white rounded-xl border-2 border-slate-100 shadow-sm p-4">
    <div className="flex items-center gap-4 mb-4">
      <ShimmerBlock className="w-12 h-12 rounded-full" />
      <div className="flex-1 space-y-2">
        <ShimmerBlock className="h-4 w-3/4" />
        <ShimmerBlock className="h-3 w-1/2" />
      </div>
    </div>
    <div className="pt-3 border-t border-slate-50 flex justify-between items-center">
      <ShimmerBlock className="h-4 w-20 rounded-md" />
      <ShimmerBlock className="h-3 w-12 rounded-md" />
    </div>
  </div>
);

export const OrgChartSkeleton = () => {
  return (
    <div className="w-full h-full bg-slate-50/50 flex flex-col items-center justify-center p-8 overflow-hidden">
      <div className="relative flex flex-col items-center gap-16">
        {/* Level 1 */}
        <div className="relative">
          <NodeSkeleton />
          {/* Vertical line down */}
          <div className="absolute top-full left-1/2 -translate-x-1/2 w-0.5 h-16 bg-slate-200" />
        </div>

        {/* Level 2 */}
        <div className="relative flex gap-20">
          {/* Horizontal connecting line */}
          <div className="absolute -top-8 left-[140px] right-[140px] h-0.5 bg-slate-200" />

          <div className="relative">
            <div className="absolute -top-8 left-1/2 -translate-x-1/2 w-0.5 h-8 bg-slate-200" />
            <NodeSkeleton />
          </div>

          <div className="relative">
            <div className="absolute -top-8 left-1/2 -translate-x-1/2 w-0.5 h-8 bg-slate-200" />
            <NodeSkeleton />
          </div>
        </div>
      </div>

      <p className="mt-12 text-slate-400 font-medium animate-pulse tracking-wide">Building organization hierarchy...</p>
    </div>
  );
};
export const TableSkeleton = ({ rows = 5 }) => {
  return (
    <div className="w-full bg-white">
      {[...Array(rows)].map((_, i) => (
        <div key={i} className="flex items-center gap-4 py-4 px-6 border-b border-slate-50 last:border-0">
          <div className="flex-[1.5] flex items-center gap-3">
            <ShimmerBlock className="w-8 h-8 rounded-full shrink-0" />
            <ShimmerBlock className="h-4 w-3/4 rounded-md" />
          </div>
          <div className="flex-1">
            <ShimmerBlock className="h-4 w-1/2 rounded-md mx-auto" />
          </div>
          <div className="flex-1">
            <ShimmerBlock className="h-4 w-2/3 rounded-md mx-auto" />
          </div>
          <div className="flex-1">
            <ShimmerBlock className="h-4 w-3/4 rounded-md mx-auto" />
          </div>
          <div className="flex-1">
            <ShimmerBlock className="h-6 w-20 rounded-full mx-auto" />
          </div>
          <div className="flex-1">
            <ShimmerBlock className="h-8 w-8 rounded-lg ml-auto" />
          </div>
        </div>
      ))}
    </div>
  );
};
